var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cc-preview-module',{staticClass:"fd-ccxs-module",attrs:{"title":"财产线索","data":_vm.transformData}},[_c('p',{staticClass:"fd-summery align-right",attrs:{"slot":"summarize"},slot:"summarize"},[_vm._v("财产总价值："+_vm._s(_vm.cczjz)+"元")])])}
var staticRenderFns = []

export { render, staticRenderFns }